export default "https://cdn-static.gokick.com/assets/a6d011c942efc1c6cd2854aca00adc3db9e08265/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";